export function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}
export function isPlainObject(obj) {
    return (obj !== null &&
        typeof obj === "object" &&
        (Object.getPrototypeOf(obj) === Object.prototype ||
            Object.getPrototypeOf(obj) === null));
}
//# sourceMappingURL=objects.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/common/objects.js
// module id = 367
// module chunks = 11